<template>
  <vx-card no-shadow v-can="'view-raw-material-company-data'">

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">
        <div class="vx-row mb-3">

          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="g_h_s_classification" name="g_h_s_classification" rules="" v-slot="{ errors }">
              <small class="label">GHS Classification</small>
              <v-select placeholder="Type and hit enter to add GHS classifications" no-drop taggable push-tags multiple :append-to-body="true" :closeOnSelect="false" v-model="form.g_h_s_classification"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="c_h_i_p_regulations" name="c_h_i_p_regulations" rules="" v-slot="{ errors }">
              <small class="label">CHIP Regulation</small>
              <v-select placeholder="Type and hit enter to add CHIP Regulations" no-drop taggable push-tags multiple :append-to-body="true" :closeOnSelect="false" v-model="form.c_h_i_p_regulations"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="i_f_r_a" name="i_f_r_a" rules="" v-slot="{ errors }">
              <small class="label">IFRA</small>
              <vs-input type="text" v-model="form.i_f_r_a" name="i_f_r_a" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="u_s_c_a_s_number" name="u_s_c_a_s_number" rules="" v-slot="{ errors }">
              <small class="label">USCAS Number</small>
              <vs-input type="text" v-model="form.u_s_c_a_s_number" name="u_s_c_a_s_number" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="e_u_c_a_s_number" name="e_u_c_a_s_number" rules="" v-slot="{ errors }">
              <small class="label">EUCAS Number</small>
              <vs-input type="text" v-model="form.e_u_c_a_s_number" name="e_u_c_a_s_number" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="commodity_code" name="commodity_code" rules="" v-slot="{ errors }">
              <small class="label">Commodity Code</small>
              <vs-input type="text" v-model="form.commodity_code" name="commodity_code" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="e_number" name="e_number" rules="" v-slot="{ errors }">
              <small class="label">E Number</small>
              <vs-input type="text" v-model="form.e_number" name="e_number" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="physical_state" name="physical_state" rules="required" v-slot="{ errors }">
              <small class="label">Physical State</small>
              <v-select :append-to-body="true" :closeOnSelect="true" v-model="form.physical_state" :options="['Liquid ', 'Powder', 'N/A']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="flash_point" name="flash_point" rules="" v-slot="{ errors }">
              <small class="label">Flash Point</small>
              <vs-input type="text" v-model="form.flash_point" name="flash_point" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
              <small class="label">Type</small>
              <v-select :append-to-body="true" :closeOnSelect="true" v-model="form.type" :options="['Natural ', 'Artificial']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="level" name="level" rules="" v-slot="{ errors }">
              <small class="label">Level</small>
              <vs-input type="text" v-model="form.level" name="level" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="sub_level" name="sub_level" rules="" v-slot="{ errors }">
              <small class="label">Sub-Level</small>
              <vs-input type="text" v-model="form.sub_level" name="sub_level" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="entry_order" name="entry_order" rules="" v-slot="{ errors }">
              <small class="label">Entry Order</small>
              <vs-input type="text" v-model="form.entry_order" name="entry_order" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_lab_test_done" name="is_lab_test_done" rules="" v-slot="{ errors }">
              <small class="label">Initial lab test done for RM use approval?</small>
              <vs-switch v-model="form.is_lab_test_done" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
        </div>
        <div  v-if="form.is_lab_test_done" class="vx-row mb-3">
          <div class="vx-col md:w-full md:mb-0">
            <vs-button @click="onClickManageQCTest" size="small" class="mt-2 float-right">Manage QC tests</vs-button>
          </div>
        </div>
<!--<pre>-->
<!--  {{form.tests}}-->
<!--</pre>-->
        <div v-if="form.is_lab_test_done" v-for="(test, index_test) in form.tests" :key="index_test" class="mt-4">
          <vx-card-custom v-on:remove="deleteTest(index_test)" :remove-card-action="form.tests.length !== 1 && form.is_lab_test_done" :collapse-action="true">
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider  :vid="index_test+'done_by'" :name="index_test+'done_by'" rules="required" v-slot="{ errors }">
                  <small class="label">Test done by</small>
                  <vs-input type="text" v-model="test.done_by" name="done_by" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider  :vid="index_test+'date'" :name="index_test+'date'" rules="required" v-slot="{ errors }">
                  <small class="label">Test date</small>
                  <flat-pickr style="display: none"
                              class="w-full"
                              :config="{ dateFormat: 'd/m/Y'}"
                              v-model="test.date"
                              placeholder="Choose Date"
                  />
                  <flat-pickr placeholder="Choose Date" class="w-full" v-model="test.date" :config="{ dateFormat: 'd/m/Y'}" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
<!--              <div class="vx-col md:w-1/5 w-full md:mb-0">-->
<!--                <small class="label">&nbsp;</small>-->
<!--                <vs-button :disabled="form.tests.length === 1 && form.is_lab_test_done" class="" @click="deleteTest(index_test)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>-->
<!--              </div>-->
            </div>

<!--          qc test loop start-->
          <div v-for="(qc_test, index_qc_test) in test.q_c_tests" :key="index_qc_test" class="mt-4">
            <div class="vx-row mb-2 ml-2">
              <div class="vx-col md:w-2/5 w-full md:mb-0">
                <ValidationProvider :vid="index_qc_test+'id'+index_test" :name="index_qc_test+'id'+index_test" rules="required" v-slot="{ errors }">
                  <small class="label">Select QC test</small>
                  <v-select :append-to-body="true" :closeOnSelect="true" label="description" v-model="qc_test.id" :reduce="option => option.id" :options="qc_tests" :dir="$vs.rtl ? 'rtl' : 'ltr'" >
                    <template v-slot:option="option">
                      {{option.description}}
                    </template>
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-2/5 w-full md:mb-0">
                <ValidationProvider  :vid="index_qc_test+'value'+index_test" :name="index_qc_test+'value'+index_test" rules="required" v-slot="{ errors }">
                  <small class="label">Test value</small>
                  <vs-input type="text" v-model="qc_test.value" name="value" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/5 w-full md:mb-0">
                <small class="label">&nbsp;</small>
                <vs-button :disabled="test.q_c_tests.length === 1" class="" @click="deleteQcTest(index_test, index_qc_test)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
              </div>
            </div>
          </div>
          <div class="vx-row mb-2 ml-2">
            <div class="vx-col md:w-2/5 w-full md:mb-0">
              <vs-button class="" @click="addQcTest(index_test)" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add QC test</vs-button>
            </div>

          </div>
          </vx-card-custom>
<!--          qc test loop end-->
        </div>

        <vs-button class="mt-8" v-if="form.is_lab_test_done" @click="addTest" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add test record</vs-button>


        <div class="vx-row mb-3 mt-8">
          <div class="vx-col w-full">
            <small class="label">General Note</small>
            <vs-textarea v-model="form.general_note" />
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_others" name="is_others" rules="" v-slot="{ errors }">
              <small class="label">Do you have any other details you want to enter?</small>
              <vs-switch v-model="form.is_others" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
        </div>

        <div v-if="form.is_others" v-for="(other, index) in form.is_other_data" :key="index" class="mt-8">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/4 w-full md:mb-0">
              <ValidationProvider  :vid="index+'name'" :name="index+'name'" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input type="text" v-model="other.name" name="name" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/4 w-full md:mb-0">
              <ValidationProvider  :vid="index+'value'" :name="index+'value'" rules="required" v-slot="{ errors }">
                <small class="label">Value</small>
                <vs-input type="text" name="value" class="w-full" v-model="other.value" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/4 w-full md:mb-0">
              <ValidationProvider  :vid="index+'comment'" :name="index+'comment'" rules="required" v-slot="{ errors }">
                <small class="label">Comment</small>
                <vs-input type="text" name="comment" class="w-full" v-model="other.comment" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/4 w-full md:mb-0">
              <small class="label">&nbsp;</small>
              <vs-button :disabled="form.is_other_data.length === 1 && form.is_others" class="" @click="deleteEnzyme(index)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
            </div>
          </div>
        </div>

        <vs-button v-if="form.is_others" @click="addEnzyme" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add other row</vs-button>


        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="dissolvable" name="dissolvable" rules="" v-slot="{ errors }">
              <small class="label">Dissolvable</small>
              <vs-switch v-model="form.dissolvable" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 md:mb-0" v-if="form.dissolvable">
            <ValidationProvider vid="dissolve_time" name="dissolve_time" rules="" v-slot="{ errors }">
              <small class="label">Dissolvable Time (hh:mm)</small>
              <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}" class="w-full"
                          v-model="form.dissolve_time"
                          placeholder="Choose Time"/>
            </ValidationProvider>
          </div>
        </div>

        <h6 class="mt-8 mb-4">Default test values</h6>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="test_type" name="test_type" rules="" v-slot="{ errors }">
              <small class="label">Test Type</small>
              <v-select :clearable="false" name="test_type" placeholder=""
                        label="name" v-model="form.test_type" :reduce="option => option.value"
                        :options="test_types" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0"
               v-if="!['Do_Not_Sample'].includes(form.test_type)">
            <ValidationProvider vid="odour" name="odour" rules="" v-slot="{ errors }">
              <small class="label">Odour</small>
              <vs-input type="text" v-model="form.odour" name="odour" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0"
               v-if="!['Do_Not_Sample'].includes(form.test_type)">
            <ValidationProvider vid="appearance" name="appearance" rules="" v-slot="{ errors }">
              <small class="label">Appearance</small>
              <vs-input type="text" v-model="form.appearance" name="appearance" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0"
               v-if="['Taste_Odour_and_Appearance_Check'].includes(form.test_type)">
            <ValidationProvider vid="taste" name="taste" rules="" v-slot="{ errors }">
              <small class="label">Taste</small>
              <vs-input type="text" v-model="form.taste" name="taste" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-4" v-if="['Odour_Appearance_SG_and_RI_Check'].includes(form.test_type)">
          <div class="vx-col md:w-1/4 w-full md:mb-0">
            <small class="label">SG</small>
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span>from</span>
                </div>
              </template>
              <vs-input class="w-full" name="sg_from" type="text"
                        v-model="form.sg_from"/>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/4 w-full md:mb-0">
            <small class="label">&nbsp;</small>
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span>to</span>
                </div>
              </template>
              <vs-input class="w-full" name="sg_to" type="text" v-model="form.sg_to"/>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/4 w-full md:mb-0">
            <small class="label">RI</small>
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span>from</span>
                </div>
              </template>
              <vs-input class="w-full" name="ri_from" type="text"
                        v-model="form.ri_from"/>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/4 w-full md:mb-0">
            <small class="label">&nbsp;</small>
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span>to</span>
                </div>
              </template>
              <vs-input class="w-full" name="ri_to" type="text" v-model="form.ri_to"/>
            </vx-input-group>
          </div>
        </div>


        <div class="flex flex-wrap items-center justify-end" v-can="'edit-raw-material-company-data'">
          <vs-button v-if="status.is_raw_material_company_data_complete"  button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4">Save and Change</vs-button>
        </div>
      </form>
    </ValidationObserver>
    <manage-q-c-test-pop-up v-on:refreshTestData="refreshTestData" ref="manageQCTestPopUp"/>
  </vx-card>

</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import ManageQCTestPopUp from '@/components/popups/raw-materials/ManageQCTestPopUp'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";
  import flatPickr from "vue-flatpickr-component";

  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  export default {
        name: "SupplierManufacturingHome",
      data() {
          return {
            form: {
              is_lab_test_done: false,
              tests: [
                {
                  done_by: "",
                  date: "",
                  q_c_tests: [
                      {
                        id: "",
                        value: ""
                      }
                    ]
                }
              ],
              is_others: false,
              is_other_data: [
                {name: '', value: '', comment: ''}
              ],
            },
            dirty: false,
            id: null,
            status: {},
            qc_tests: [],
            test_types: [
              {name: 'Do Not Sample', value: 'Do_Not_Sample'},
              {name: 'Odour and Appearance Check', value: 'Odour_and_Appearance_Check'},
              {name: 'Taste Odour and Appearance Check', value: 'Taste_Odour_and_Appearance_Check'},
              {name: 'Odour Appearance SG and RI Check', value: 'Odour_Appearance_SG_and_RI_Check'}
            ],
          }
      },
      mixins: [SuccessMessage, ErrorMessages],
      components: {
        'v-select': vSelect,
        flatPickr,
        ManageQCTestPopUp
      },
      methods: {
        onClickNext() {
          this.$emit('notify', 1)
        },
        onClickSubmit() {
          this.status.is_raw_material_company_data_complete ? this.onClickUpdate() : this.onClickCreate()
        },

        async onClickUpdate() {
          this.$vs.loading()
          try {
            if (!this.form.is_others) {
              this.form.is_other_data = []
            }
            if (!this.form.is_lab_test_done){
              this.form.tests = []
            }
            const data= (await SupplierRawMaterialRepository.UpdateRawMaterialCompanyData(this.id, this.form))
            this.showSuccessMessage('Raw Material Company Details Updated!')
            this.dirty = false
            // this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },
        async onClickCreate() {
          this.$vs.loading()
          try {
            if (!this.form.is_others) {
              this.form.is_other_data = []
            }
            if (!this.form.is_lab_test_done){
              this.form.tests = []
            }
            const data= (await SupplierRawMaterialRepository.CreateRawMaterialCompanyData(this.form))
            this.showSuccessMessage('Raw Material Company Details Created!')
            // this.onClickNext()
            await this.loadStatus()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },

        async loadData() {
          this.$vs.loading()
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialCompanyData(this.id)).data
          this.form =data
          if (!this.form.is_others) {
            this.addEnzyme()
          }
          if (!this.form.is_lab_test_done) {
            this.addTest()
          }
          this.$vs.loading.close()
        },
        async loadStatus() {
          this.$vs.loading()
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
          this.status =data
          this.$vs.loading.close()
          await this.fetchTestData()
        },
        async fetchTestData() {
          this.$vs.loading()
          this.qc_tests = (await SupplierRawMaterialRepository.getRawMaterialQCTests(this.id)).data.data
          this.$vs.loading.close()
        },
        addEnzyme() {
          this.form.is_other_data.push(
            {name: '', value: '', comment: ''}
          )
        },
        addTest() {
          this.form.tests.push(
            {done_by: "", date: "", q_c_tests: [ {id: "", value: ""} ]}
          )
        },
        addQcTest(test_index) {
          this.form.tests[test_index].q_c_tests.push(
            {id: '', value: ''}
          )
        },
        deleteEnzyme(index) {
          this.form.is_other_data.splice(index, 1)
        },
        deleteTest(index) {
          this.form.tests.splice(index, 1)
        },
        deleteQcTest(test_index, qc_test_index) {
          this.form.tests[test_index].q_c_tests.splice(qc_test_index, 1)
        },
        async onClickManageQCTest() {
          await this.$refs.manageQCTestPopUp.openPopup()
        },
        async refreshTestData() {
          await this.fetchTestData()
        }
      },
      async mounted() {
        this.id = this.$route.params.id
        this.form.supplier_raw_material_id =  this.id
        await this.loadStatus()
        if (this.status.is_raw_material_company_data_complete) {
          await this.loadData()
          this.dirty = false
        }
      },
      beforeDestroy() {
        // window.confirm("Do you really want to leave?")
      },
    watch: {
          form:
            {
              handler(newVal, oldVal)
              {
                this.dirty = true;
              },
              deep: true
            }
        }
    }
</script>

<style scoped>

</style>
